import { Checkbox } from "@dune/ui";
import { useFormContext, useWatch } from "react-hook-form";
import { defaultActionValues } from "./useConstructionSiteDetailsForm";
import { useMe } from "../../../api/queries/users.queries";
import { useMemo } from "react";
import { RoleEnum } from "../../../../../../packages/vars/src";

const IfSyndicOptionsContainer = ({
	disabled = false,
}: { disabled?: boolean }) => {
	const {
		control,
		setValue,
		formState: { errors },
	} = useFormContext();
	const { me } = useMe();
	const currentUserIsSyndic = useMemo(
		() => me?.role === RoleEnum.SYNDIC,
		[me?.role],
	);
	const actionsValue = useWatch({
		control,
		name: "actions",
	});

	const error = errors.actions?.types;

	return (
		<div className="flex flex-col gap-4">
			Elle concerne :
			{error?.message && (
				<span className="text-red-500 text-sm">
					{error?.message?.toString()}
				</span>
			)}
			<div className="flex flex-row gap-4">
				<Checkbox
					id={"commonParts"}
					label={"des parties communes"}
					checked={
						actionsValue.types.includes("SYNDIC") &&
						actionsValue.buildingType === "COMMON_PARTS"
					}
					onCheckedChange={(checked) => {
						if (checked) {
							setValue("actions", {
								...defaultActionValues,
								types: ["SYNDIC"],
								buildingType: "COMMON_PARTS",
							});
						} else if (currentUserIsSyndic) {
							setValue("actions", {
								...defaultActionValues,
								types: ["SYNDIC"],
								buildingType: "PRIVATE_WORK",
							});
						} else {
							setValue("actions", defaultActionValues);
						}
					}}
					className="border-gray-300 disabled:bg-gray-100"
					disabled={disabled}
				/>
				<Checkbox
					id={"privateWork"}
					label={"des travaux privatifs"}
					checked={
						actionsValue.types.includes("SYNDIC") &&
						actionsValue.buildingType === "PRIVATE_WORK"
					}
					onCheckedChange={(checked) => {
						if (checked) {
							setValue("actions", {
								...defaultActionValues,
								types: ["SYNDIC"],
								buildingType: "PRIVATE_WORK",
							});
						} else if (currentUserIsSyndic) {
							setValue("actions", {
								...defaultActionValues,
								types: ["SYNDIC"],
								buildingType: "COMMON_PARTS",
							});
						} else {
							setValue("actions", defaultActionValues);
						}
					}}
					className="border-gray-300 disabled:bg-gray-100"
					disabled={disabled}
				/>
			</div>
		</div>
	);
};

export default IfSyndicOptionsContainer;
